import { render, staticRenderFns } from "./UserBaseBalloon.vue?vue&type=template&id=742bc649&scoped=true"
import script from "./UserBaseBalloon.vue?vue&type=script&lang=ts"
export * from "./UserBaseBalloon.vue?vue&type=script&lang=ts"
import style0 from "./UserBaseBalloon.vue?vue&type=style&index=0&id=742bc649&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742bc649",
  null
  
)

export default component.exports